// src/stripe.ts
var EST_STRIPE_API_VERSION = "2022-11-15";
var TRANSACTION_TYPES = {
  INVOICE: "INVOICE",
  INVESTMENT: "INVESTMENT"
};
var EST = "Equity Stock Transfer";
var EQUIDEFI = "EquiDeFi";
var ACCOUNT_TYPES = {
  EST,
  EQUIDEFI
};
var STRIPE_DECLINE_MESSAGE_DEFAULT = "The payment could not be processed. Please try again or use a different payment method.";
var STRIPE_DECLINE_CONTACT_BANK = "The card was declined. Please contact the card issuer for more information.";
var STRIPE_DECLINE_TRY_AGAIN = "The payment could not be processed right now. Please try again in a few minutes or use a different payment method.";
var STRIPE_DECLINE_MESSAGES = {
  // Funds / limits
  insufficient_funds: "The card has insufficient funds. Please use a different payment method.",
  card_velocity_exceeded: "The card has been used too many times recently. Please wait and try again, or use a different card.",
  withdrawal_count_limit_exceeded: "The card has reached its withdrawal limit. Please use a different payment method or contact the bank.",
  invalid_amount: "The payment amount isn't supported by the card. Please use a different payment method.",
  // Generic issuer declines — advise contacting the bank
  do_not_honor: STRIPE_DECLINE_CONTACT_BANK,
  generic_decline: STRIPE_DECLINE_CONTACT_BANK,
  call_issuer: STRIPE_DECLINE_CONTACT_BANK,
  no_action_taken: STRIPE_DECLINE_CONTACT_BANK,
  service_not_allowed: STRIPE_DECLINE_CONTACT_BANK,
  transaction_not_allowed: STRIPE_DECLINE_CONTACT_BANK,
  not_permitted: "The card doesn't allow this type of purchase. Please use a different payment method.",
  card_not_supported: "The card doesn't support this type of purchase. Please use a different payment method.",
  currency_not_supported: "The card doesn't support this currency. Please use a different payment method.",
  restricted_card: STRIPE_DECLINE_CONTACT_BANK,
  // Fraud / security — keep generic, never disclose the reason
  lost_card: STRIPE_DECLINE_CONTACT_BANK,
  stolen_card: STRIPE_DECLINE_CONTACT_BANK,
  fraudulent: STRIPE_DECLINE_CONTACT_BANK,
  pickup_card: STRIPE_DECLINE_CONTACT_BANK,
  merchant_blacklist: STRIPE_DECLINE_CONTACT_BANK,
  security_violation: STRIPE_DECLINE_CONTACT_BANK,
  revocation_of_authorization: STRIPE_DECLINE_CONTACT_BANK,
  revocation_of_all_authorizations: STRIPE_DECLINE_CONTACT_BANK,
  stop_payment_order: STRIPE_DECLINE_CONTACT_BANK,
  // Card details
  expired_card: "The card has expired. Please use a different payment method.",
  incorrect_number: "The card number is incorrect. Please check the details and try again.",
  invalid_number: "The card number is invalid. Please check the details and try again.",
  incorrect_cvc: "The card's security code (CVC) is incorrect. Please check it and try again.",
  invalid_cvc: "The card's security code (CVC) is invalid. Please check it and try again.",
  incorrect_zip: "The card's postal code doesn't match. Please check it and try again.",
  invalid_expiry_month: "The card's expiration month is invalid. Please check it and try again.",
  invalid_expiry_year: "The card's expiration year is invalid. Please check it and try again.",
  incorrect_pin: "The PIN entered is incorrect. Please try again.",
  invalid_pin: "The PIN entered is invalid. Please try again.",
  invalid_account: "The card account is invalid. Please use a different payment method.",
  // Transient — retry
  processing_error: STRIPE_DECLINE_TRY_AGAIN,
  issuer_not_available: STRIPE_DECLINE_TRY_AGAIN,
  try_again_later: STRIPE_DECLINE_TRY_AGAIN,
  reenter_transaction: STRIPE_DECLINE_TRY_AGAIN,
  approve_with_id: STRIPE_DECLINE_TRY_AGAIN,
  duplicate_transaction: "This payment looks like a duplicate. Please check before trying again.",
  testmode_decline: "This is a test-mode declined card."
};
function getStripeDeclineMessage(code, fallbackMessage) {
  if (code && STRIPE_DECLINE_MESSAGES[code]) {
    return STRIPE_DECLINE_MESSAGES[code];
  }
  return fallbackMessage || STRIPE_DECLINE_MESSAGE_DEFAULT;
}
var APPEARANCE = {
  theme: "stripe",
  variables: {
    colorPrimary: "#0570de",
    colorBackground: "#ffffff",
    colorText: "#30313d",
    colorDanger: "#df1b41",
    fontFamily: "Ideal Sans, system-ui, sans-serif",
    spacingUnit: "2px",
    borderRadius: "4px"
  }
};
export {
  ACCOUNT_TYPES,
  APPEARANCE,
  EQUIDEFI,
  EST,
  EST_STRIPE_API_VERSION,
  STRIPE_DECLINE_MESSAGES,
  STRIPE_DECLINE_MESSAGE_DEFAULT,
  TRANSACTION_TYPES,
  getStripeDeclineMessage
};
//# sourceMappingURL=stripe.mjs.map